/**
 * Report Configuration Query Hooks
 *
 * Custom hooks for fetching tenant configuration related to reporting features.
 */

import { useQuery } from '@tanstack/react-query';
import { tenantSettingsApi } from '@xtnd/web/features/settings/api/tenantSettingsApi';

/**
 * Query keys for report configuration
 */
export const REPORT_CONFIG_QUERY_KEYS = {
    tenantConfig: ['tenant-config'] as const,
};

/**
 * Hook for fetching tenant configuration to check if reporting modules are enabled
 * Reuses the same query key as other features to share cache
 */
export function useReportTenantConfig() {
    return useQuery({
        queryKey: REPORT_CONFIG_QUERY_KEYS.tenantConfig,
        queryFn: () => tenantSettingsApi.getCurrentTenantConfig(),
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes
        retry: 2,
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    });
}

